const plans = {
  essentials: {
    annual: '0',
    monthly: '0'
  },
  growth: {
    annual: '48',
    monthly: '56'
  },
  business: {
    annual: '399',
    monthly: '490'
  }
}

const trustScore = {
  unlock: '16.99'
}

const prices = {
  plans,
  trustScore
}

export default prices
